import {
  Label,
  RangeDatePicker,
} from '@sede-enterprise/shell-ds-react-framework';
import { UK_TIMEZONE } from '@see-power-pft-common-js/utils/product-mapper';
import { formatInTimeZone } from 'date-fns-tz';
import dayjs, { Dayjs } from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import { DateRangeSelectorWrapper } from 'pages/Availability/common/DateRangeSelector/DateRangeSelector.styled';
import { useStore } from 'store';

dayjs.extend(weekday);
dayjs.extend(localeData);

const DateRangeSelector = () => {
  const [currentDateRange, setDateRange] = useStore((state) => [
    state.availabilityDateRange,
    state.setAvailabilityDateRange,
  ]);
  const dateChangeHandler = (
    values: [Dayjs | null, Dayjs | null] | null,
    _: [string, string],
  ) => {
    if (values) {
      const [start, end] = values;
      if (start && end) {
        setDateRange({
          start: start.toISOString(),
          end: end.toISOString(),
        });
      }
    }
  };

  const ukStartDate = formatInTimeZone(
    currentDateRange.start,
    UK_TIMEZONE,
    'yyyy-MM-dd',
  );
  const ukEndDate = formatInTimeZone(
    currentDateRange.end,
    UK_TIMEZONE,
    'yyyy-MM-dd',
  );

  return (
    <DateRangeSelectorWrapper>
      <Label style={{ color: '#757575' }}>Timeframe</Label>
      <RangeDatePicker
        placeholder={['Start date', 'Finish date']}
        onChange={dateChangeHandler}
        value={[dayjs(ukStartDate), dayjs(ukEndDate)]}
      />
    </DateRangeSelectorWrapper>
  );
};

export default DateRangeSelector;
